const version = "V3.0-@20250401";
const sysname = "嘉恒储运发动机结算系统";
export default {
  version, // 系统版本号
  sysname, // 系统名称
};
